<span *ngIf="accessEnable">
<div class="alert alert-danger alert-dismissible" *ngIf="errorMessage !== ''" role="alert">
  {{errorMessage}}<mat-icon class="close-icon" (click)="closeAlert()">close</mat-icon>
</div>
<div class="alert alert-success alert-dismissible" *ngIf="successMessage !== ''" role="alert">
  {{successMessage}}<mat-icon class="close-icon" (click)="closeAlert()">close</mat-icon>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">{{spinnerMessage}}</p>
</ngx-spinner>

<ng-container>

  <!-- FILTER PANEL -->
  <mat-accordion class="example-headers-align">
    <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title><strong>Search</strong></mat-panel-title>
      </mat-expansion-panel-header>

      <mat-form-field>
        <mat-label>Upload Type</mat-label>
        <mat-select [typeaheadDebounceInterval]="500" [(ngModel)]="filterProcNm" name="filterProcNm">
          <mat-option [value]="null"></mat-option>
          <mat-option *ngFor="let u of UPLOAD_PROC_NAMES" [value]="u.proc_nm">{{u.label}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Status</mat-label>
        <mat-select [typeaheadDebounceInterval]="500" [(ngModel)]="filterProcSts" name="filterProcSts">
          <mat-option [value]="null"></mat-option>
          <mat-option *ngFor="let s of STATUS_OPTIONS" [value]="s">{{s}}</mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-button style="float: right;" (click)="reset()">Reset</button>
      <button mat-button style="float: right;" (click)="search()">Search</button>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- ACTIONS -->
  <div class="d-flex mt-2 mb-1">
    <button mat-raised-button (click)="openEditDialog()">Edit</button>
  </div>

  <!-- FIXED 5-ROW GRID -->
  <ngx-datatable #myTable class="material striped" [rows]="rows"
    [columnMode]="ColumnMode.force" [headerHeight]="45" [footerHeight]="false"
    rowHeight="30"
    [selected]="selected" [selectionType]="SelectionType.single"
    [selectAllRowsOnPage]="false" [displayCheck]="displayCheck"
    (select)="onSelect($event)" [selectCheck]="singleSelectCheck"
    [ngClass]="{'hideerror': showdata, 'showerror': !showdata}">

    <ngx-datatable-column [width]="65" [sortable]="false" [canAutoResize]="false"
      [draggable]="false" [resizeable]="false" [checkboxable]="true" name="Select">
    </ngx-datatable-column>

    <ngx-datatable-column name="Upload Type" prop="proc_label"></ngx-datatable-column>

    <ngx-datatable-column name="Status" prop="proc_status">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span [class]="'status-badge ' + statusClass(row.proc_status)">{{row.proc_status || 'NOT_STARTED'}}</span>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Email Id" prop="email_id"></ngx-datatable-column>
    <ngx-datatable-column name="Updated By" prop="update_by_id"></ngx-datatable-column>
    <ngx-datatable-column name="Updated Ts" prop="update_ts"></ngx-datatable-column>

  </ngx-datatable>

</ng-container>
</span>

